import React, { useState, useEffect } from "react";
import { Drawer, List, ListItemButton, ListItemIcon, ListItemText, Toolbar, Divider, Collapse, useMediaQuery, } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ImageIcon from "@mui/icons-material/Image";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SettingsIcon from "@mui/icons-material/Settings";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PeopleIcon from "@mui/icons-material/People";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import { useNavigate, useLocation } from "react-router-dom";
const drawerWidth = 300;
export default function Sidebar({ open, setOpen }) {
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = useMediaQuery("(max-width:900px)");
    const [masterOpen, setMasterOpen] = useState(
        location.pathname.startsWith("/masters")
    );
    useEffect(() => {
        if (isMobile) {
            setOpen(false);
        }
    }, [isMobile, setOpen]);
    useEffect(() => {
        if (location.pathname.startsWith("/masters")) {
            setMasterOpen(true);
        }
    }, [location.pathname]);
    const handleNavigate = (path) => {
        navigate(path);
        if (isMobile) setOpen(false);
    };
    const isActive = (path) => location.pathname === path;
    const handleMasterClick = () => {
        setMasterOpen((prev) => !prev);
    };
    return (
        <Drawer variant={isMobile ? "temporary" : "permanent"} open={open} onClose={() => setOpen(false)} sx={{ width: drawerWidth, flexShrink: 0, "& .MuiDrawer-paper": { width: drawerWidth, boxSizing: "border-box", }, }}>
            <Toolbar><h3>Jewellery Admin</h3></Toolbar>
            <Divider />
            <List>
                <ListItemButton selected={isActive("/dashboard")} onClick={() => handleNavigate("/dashboard")}>
                    <ListItemIcon><DashboardIcon /></ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItemButton>
                <Divider />
                <ListItemButton onClick={handleMasterClick}>
                    <ListItemIcon><SettingsIcon /></ListItemIcon>
                    <ListItemText primary="Masters" />
                    {masterOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItemButton>
                <Collapse in={masterOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/state")} onClick={() => handleNavigate("/masters/state")}>
                            <ListItemIcon>
                                <span className="material-symbols-outlined">map</span>
                            </ListItemIcon>
                            <ListItemText primary="State" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/district")} onClick={() => handleNavigate("/masters/district")}>
                            <ListItemIcon>
                                <span className="material-symbols-outlined">location_city</span>
                            </ListItemIcon>
                            <ListItemText primary="District" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/plan-category")} onClick={() => handleNavigate("/masters/plan-category")}>
                            <ListItemIcon>
                                <span className="material-symbols-outlined">category</span>
                            </ListItemIcon>
                            <ListItemText primary="Main Category" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/product-category")} onClick={() => handleNavigate("/masters/product-category")}>
                            <ListItemIcon>
                                <span className="material-symbols-outlined">inventory_2</span>
                            </ListItemIcon>
                            <ListItemText primary="Sub Category" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/age-category")} onClick={() => handleNavigate("/masters/age-category")}>
                            <ListItemIcon>
                                <span className="material-symbols-outlined">groups</span>
                            </ListItemIcon>
                            <ListItemText primary="Age Category" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/color-category")} onClick={() => handleNavigate("/masters/color-category")}>
                            <ListItemIcon>
                                <span className="material-symbols-outlined">palette</span>
                            </ListItemIcon>
                            <ListItemText primary="Color Category" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/size-category")} onClick={() => handleNavigate("/masters/size-category")}>
                            <ListItemIcon>
                                <span className="material-symbols-outlined">straighten</span>
                            </ListItemIcon>
                            <ListItemText primary="Size Category" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/brand")} onClick={() => handleNavigate("/masters/brand")}>
                            <ListItemIcon>
                                <span className="material-symbols-outlined">branding_watermark</span>
                            </ListItemIcon>
                            <ListItemText primary="Brand" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/tax")} onClick={() => handleNavigate("/masters/tax")}>
                            <ListItemIcon>
                                <span className="material-symbols-outlined">receipt_long</span>
                            </ListItemIcon>
                            <ListItemText primary="Tax" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/courier")} onClick={() => handleNavigate("/masters/courier")}>
                            <ListItemIcon>
                                <span className="material-symbols-outlined">local_shipping</span>
                            </ListItemIcon>
                            <ListItemText primary="Courier" />
                        </ListItemButton>
                    </List>
                </Collapse>
                <Divider />
                <ListItemButton selected={isActive("/banner")} onClick={() => handleNavigate("/banner")}>
                    <ListItemIcon><ImageIcon /></ListItemIcon>
                    <ListItemText primary="Banner" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/shipping-charges")} onClick={() => handleNavigate("/shipping-charges")}>
                    <ListItemIcon><LocalShippingIcon /></ListItemIcon>
                    <ListItemText primary="Shipping Charges" />
                </ListItemButton>
                <Divider />
                {/* <ListItemButton selected={isActive("/supplier")} onClick={() => handleNavigate("/supplier")}>
                    <ListItemIcon><PeopleIcon /></ListItemIcon>
                    <ListItemText primary="Supplier" />
                </ListItemButton> */}
                <Divider />
                <ListItemButton selected={isActive("/products")} onClick={() => handleNavigate("/products")}>
                    <ListItemIcon><Inventory2Icon /></ListItemIcon>
                    <ListItemText primary="Products" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/coupon")} onClick={() => handleNavigate("/coupon")}>
                    <ListItemIcon><LocalMallIcon  /></ListItemIcon>
                    <ListItemText primary="Coupon" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/user")} onClick={() => handleNavigate("/user")}>
                    <ListItemIcon><PeopleIcon  /></ListItemIcon>
                    <ListItemText primary="User List" />
                </ListItemButton>
                <Divider />

            </List>
        </Drawer>
    );
}